<template>
    <section>
        <o-field label="Small">
            <o-skeleton size="small" />
        </o-field>

        <o-field label="Default">
            <o-skeleton />
        </o-field>

        <o-field label="Medium">
            <o-skeleton size="medium" />
        </o-field>

        <o-field label="Large">
            <o-skeleton size="large" />
        </o-field>
    </section>
</template>
